<template>
  <transition name="fade" mode="out-in">
    <div :class="['text-center', centered]">
      <i class="fas fa-circle-notch fa-spin fa-2x loader"></i>
      <p class="text-center" v-if="message" v-html="message"/>
    </div>
  </transition>
</template>

<script>
export default {
  name: "loader",
  props: {
    message: String,
    center: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    centered() {
      return this.center ? 'loader-container' : '';
    }
  }
}
</script>

<style>
.text-white {
  color: #ffffff !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Layout/Loader.vue